import { FacetType } from '@features/facetingEngine/types';
import { BooleanFilter } from './BooleanFilter';
import { DateFilter } from './DateFilter';
import { RangeFilter } from './RangeFilter';

interface FacetControlProps {
    facetKey: string;
    type: FacetType;
}

export const FacetControl = ({ facetKey, type }: FacetControlProps) => {
    switch (type) {
        case 'boolean':
            return <BooleanFilter facetKey={facetKey} />;
        case 'range':
            return <RangeFilter facetKey={facetKey} />;
        case 'date':
            return <DateFilter facetKey={facetKey} />;
        default:
            return null;
    }
};
